import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AgentDocumentData } from '../components/sidebar/constants/constants';

interface AgentDocuments {
  documentsData: AgentDocumentData[];
}

const initialState: AgentDocuments = {
  documentsData: []
};

export const agentDocumentSlice = createSlice({
  name: 'agentDocumentSlice',
  initialState,
  reducers: {
    setDocumentsData: (state, action: PayloadAction<AgentDocumentData[]>) => {
      state.documentsData = action.payload;
    }
  }
});

export const { setDocumentsData } = agentDocumentSlice.actions;

export default agentDocumentSlice.reducer;
